import { render, staticRenderFns } from "./Doodle.vue?vue&type=template&id=5667a268&scoped=true"
import script from "./Doodle.vue?vue&type=script&lang=js"
export * from "./Doodle.vue?vue&type=script&lang=js"
import style0 from "./Doodle.vue?vue&type=style&index=0&id=5667a268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667a268",
  null
  
)

export default component.exports